<script setup lang='ts'>
import { onMounted, onUnmounted } from 'vue';

import useCartWidget from '@/composables/useCartWidget';

const props = defineProps<{
  top: string | null;
  right: string | null;
}>();

const { itemsCount, handleCartEvent, loadProductsFromLocalStorage } = useCartWidget();

onMounted(() => {
  loadProductsFromLocalStorage();
  window.addEventListener('message', handleCartEvent);
});

onUnmounted(() => window.removeEventListener('message', handleCartEvent));
</script>

<template>
  <div v-if="itemsCount >= 1" class="cart_count" :style="`top:${props.top ?? 0}px;right:${props.right ?? 0}px`">
    {{ itemsCount }}
  </div>
</template>

<style scoped>
.cart_count {
  --size: 14px;
  position: absolute;
  width: var(--size);
  height: var(--size);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: hsl(353, 65%, 47%);
  color: var(--yb-color-white);
  font-size: 12px;
  font-weight: var(--yb-text-bold);
  padding: 2px;
  border-radius: 50%;
  z-index: 5;
}
</style>
